import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { InfluencersPage } from './pages/InfluencersPage';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlox4inz7z9l">
      <ScrollToTop data-id="element-1" data-mp="2rit14zvovkns" />
      <div className="min-h-screen flex flex-col w-full" data-id="element-2" data-mp="2mlua4q7bnttt">
        <Nav data-id="element-3" data-mp="2mndpmel5m0uj" />
        <main className="flex-grow flex flex-col" data-id="element-4" data-mp="2mnne1xqjvzy4">
          <Routes data-id="element-5" data-mp="31ayr642drs0c">
            <Route path="/" element={<Home data-id="element-7" data-mp="31c1ksjr388jy" />} data-id="element-6" data-mp="31bic7tnbuwil" />
            <Route path="/about" element={<AboutPage data-id="element-9" data-mp="2wjqgz5t882m4" />} data-id="element-8" data-mp="2wk09b01quluz" />
            <Route path="/influencers" element={<InfluencersPage data-id="element-11" data-mp="2wi5pxq64f1t0" />} data-id="element-10" data-mp="2wiffxdr618yp" />
            <Route path="/contact" element={<ContactPage data-id="element-13" data-mp="28suv0pbgc1ms" />} data-id="element-12" data-mp="28tmdqzjya4vn" />
          </Routes>
        </main>
        <Footer data-id="element-14" data-mp="23w4fc33k781w" />
      </div>
    </BrowserRouter>;
}